"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createBreakpoints = exports.DEFAULT_BREAKPOINTS = void 0;
var _Breakpoint = require("./Breakpoint");
var _breakpointMediaQuery = require("./breakpointMediaQuery");
var _useBreakpoint = require("./useBreakpoint");
const DEFAULT_BREAKPOINTS = exports.DEFAULT_BREAKPOINTS = {
  mobile: 640,
  tablet: 1000,
  desktop: 1800
};
const createBreakpoints = function () {
  let breakpoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_BREAKPOINTS;
  return {
    ...(0, _useBreakpoint.createBreakpointHooks)(breakpoints),
    ...(0, _Breakpoint.createBreakpointComponents)(breakpoints),
    mediaQuery: (0, _breakpointMediaQuery.createBreakpointMediaQueries)(breakpoints)
  };
};
exports.createBreakpoints = createBreakpoints;
var _default = exports.default = createBreakpoints;